<template>
  <span>{{ wallet.coupon | balanceValue }}</span>
</template>

<script>
import Device        from '../libs/device';
import WalletBalance from './wallet-balance';

export default {
  name  : 'CouponBalance',
  mixins: [WalletBalance],
  props : {
    device: {
      type   : Device,
      default: null,
    },
  },
};
</script>
